import { useEffect, useRef } from 'react';
import MixingCard from '../components/MixingCard';
import PeriodicTable from '../components/PeriodicTable';
import LabGuide from '../components/LabGuide';
import AdSlot from '../components/AdSlot';
import { useRouter } from '../context/RouterContext';
import { readPickedIds } from '../utils/routeUtils';
import useAssistant from '../hooks/useAssistant';
import useMixingLab from '../hooks/useMixingLab';
import { LAB_CLASSES } from '../constants/classNames';
import { ADSENSE_SLOTS, MAX_SELECTED_SUBSTANCES } from '../constants/config';
import { scrollToElementIfHidden } from '../utils/domUtils';
import '../styles/LabPage.css';

export default function LabPage() {
  const { search } = useRouter();
  const assistantState = useAssistant();
  const lab = useMixingLab(assistantState, readPickedIds(search));
  const benchRef = useRef(null);
  const isBenchFull = lab.selectedIds.length === MAX_SELECTED_SUBSTANCES;

  // The table is below the bench, so bring the Mix button back into view once two are picked.
  useEffect(() => {
    if (isBenchFull) scrollToElementIfHidden(benchRef.current);
  }, [isBenchFull]);

  // On phones the Mix button sits below the scene, so make sure the kid and beaker are on screen when mixing.
  useEffect(() => {
    if (lab.mixCount > 0) scrollToElementIfHidden(benchRef.current);
  }, [lab.mixCount]);

  return (
    <div className={LAB_CLASSES.root}>
      <section className={LAB_CLASSES.intro}>
        <h1 className={LAB_CLASSES.heading}>Welcome to the Mixing Lab!</h1>
        <p className={LAB_CLASSES.subheading}>
          Pick two elements from the periodic table, press Mix and watch what happens. It's all pretend, so you can
          experiment as much as you like.
        </p>
      </section>

      <div className={LAB_CLASSES.bench} ref={benchRef}>
        <MixingCard lab={lab} assistantState={assistantState} />
      </div>

      <PeriodicTable substances={lab.allSubstances} selectedIds={lab.selectedIds} onSelectSubstance={lab.toggleSubstance} />

      <LabGuide />

      <AdSlot slotId={ADSENSE_SLOTS.PAGE_BOTTOM} />
    </div>
  );
}
